import { render } from "./ComponenteCostes.vue?vue&type=template&id=30ad31e8"
import script from "./ComponenteCostes.vue?vue&type=script&lang=js"
export * from "./ComponenteCostes.vue?vue&type=script&lang=js"

import "./ComponenteCostes.vue?vue&type=style&index=0&id=30ad31e8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__